<sfcu-loader></sfcu-loader>
<main role="main" [style.visibility]="isLoading() ? 'hidden' : 'visible'">
    <sfcu-breadcrumb [isRed]="isRed"/>
    <router-outlet/>
</main>
